module.exports = __webpack_public_path__ + "img/linkedin_logo.cbd48639.svg";